module.exports = __webpack_public_path__ + "img/7-5.10b3efae.png";